// Event bus ultra-léger pour rafraîchir les cartes Dashboard après mutation.
// Usage côté mutation : notifyDataChanged('transaction' | 'depense' | 'depot' | 'session' | 'date-modifiee')
// Usage côté listener (Dashboard cards) : useDataChangeListener(() => refetch())

import { useEffect, useRef } from 'react';

const EVENT = 'playcity:data-changed';

export const notifyDataChanged = (kind = 'any', payload = null) => {
  try {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { kind, payload, ts: Date.now() } }));
  } catch (_) { /* noop */ }
};

export const useDataChangeListener = (cb) => {
  const ref = useRef(cb);
  ref.current = cb;
  useEffect(() => {
    const h = (e) => { try { ref.current && ref.current(e.detail); } catch (_) {} };
    window.addEventListener(EVENT, h);
    // Refetch quand le user revient sur l'onglet / la PWA (utile si data a changé pendant absence)
    const onVis = () => { if (document.visibilityState === 'visible') { try { ref.current && ref.current({ kind: 'visibility' }); } catch (_) {} } };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      window.removeEventListener(EVENT, h);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);
};
